let _inv = {
  LOCAL: {
    url: 'http://localhost:5000/',
    client_id: 'wordpress_cid',
    client_secret: 'secret_wordpress_secret',
    stripe_key: 'pk_test_yiMiasFT9LExt16uqORYl7Pu',
    webhook_bedaddy: 'https://hooks.slack.com/services/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',
  },
  DEV: {
    url: 'https://dev.apis.bedaddy.fr/',
    client_id: 'wordpress_cid',
    client_secret: 'secret_wordpress_secret',
    stripe_key: 'pk_test_yiMiasFT9LExt16uqORYl7Pu',
    webhook_bedaddy: 'https://hooks.slack.com/services/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',
  },
  PRODUCTION: {
    url: 'https://apis.bedaddy.fr/',
    client_id: 'p_cid_0a359f9d17e2c85e539f6cf6bee15462',
    client_secret: 'a25cf1f8ab187f83ccfb6de8b1f13b9e',
    stripe_key: 'pk_live_ukCoazb7cGxiO7maxI8hepNj',
    webhook_bedaddy: 'https://hooks.slack.com/services/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',
  },
  ENVIRONMENT: 'PRODUCTION',
};

module.exports = {
  getApiPath: () => {
    return _inv[_inv.ENVIRONMENT].url;
  },

  getApiClient: () => {
    let data = _inv[_inv.ENVIRONMENT];
    return {
      client_id: data.client_id,
      client_secret: data.client_secret,
    };
  },
  getEnvironment: () => {
    console.log(_inv.ENVIRONMENT);
    return _inv.ENVIRONMENT;
  },

  getWebhook_bedaddy: ()=> {
    return _inv[_inv.ENVIRONMENT].webhook_bedaddy
  },

  STRIPE_KEY: _inv[_inv.ENVIRONMENT].stripe_key,
};



// WEBPACK FOOTER //
// ./constants/ApiConstants.js